module.exports = __webpack_public_path__ + "static/media/pending.471596ae.gif";